import React from 'react';
import DebtTableRow from './DebtTableRow';

const DebtsTable = ({ debts }) => {
    const debtsTableRows = [];
    debts.forEach(debt => {
        debtsTableRows.push(<DebtTableRow key={debt.id} {...debt} />);
    });
    return (
        <div className="card card-transparent">
            <div className="card-title border-0">
                <h5 className="text-muted">Débitos Pagos</h5>
            </div>
            <table className="table">
                <thead>
                    <tr>
                        <th>Débito</th>
                        <th className="text-right">Valor</th>
                    </tr>
                </thead>
                <tbody>{debtsTableRows}</tbody>
            </table>
        </div>
    );
}

export default DebtsTable;



// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/DebtsTable.js